<template>
    <div class="sidebar">
        <ul class="nav-list">
            <li>
                <router-link to="/orders">
                    <i class="bx bx-shopping-bag"></i>
                    <span class="links_name">Лиды</span>
                </router-link>
                <span class="tooltip">Лиды</span>
            </li>
            <li>
                <router-link to="/profile">
                    <i class="bx bx-user"></i>
                    <span class="links_name">Мой профиль</span>
                </router-link>
                <span class="tooltip">Мой профиль</span>
            </li>
        </ul>
        <div class="tsoft-active-section">
            <span>{{ handlerActivePageName() }}</span>
        </div>
        <div class="tsoft-sidebar-button">
            <i class="bx bx-menu" id="btn" @click="handlerOpenOrCloseMenu"></i>
        </div>
        <div class="app-version" v-if="visible">
            <span class="version-text">Версия: {{ appVersion }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            handlerSidebar: false,
            visible: false,
        };
    },
    computed: {
        ...mapGetters('auth', ['currentUser', 'isAuthenticated']),
        appVersion() {
            return window.CLIENT_VERSION || '0.9.112';
        },
    },
    mounted() {
        if (this.$store.state.userLocalSettings.interfaceSettings.sidebarMenu === 'open') {
            setTimeout(() => {
                this.handlerOpenOrCloseMenu();
            }, 500);
        }
    },
    watch: {
        visible(value) {
            this.$store.dispatch('userLocalSettings/SET_INTERFACE_SETTINGS', {
                name: 'sidebarMenu',
                value: value ? 'open' : '',
            });
        },
    },
    methods: {
        handlerOpenOrCloseMenu() {
            const sidebar = document.querySelector('.sidebar');
            const closeBtn = document.querySelector('#btn');
            const activeSection = document.querySelector('.tsoft-active-section');

            const menuBtnChange = () => {
                if (sidebar.classList.contains('open')) {
                    this.visible = true;
                    closeBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
                } else {
                    this.visible = false;
                    closeBtn.classList.replace('bx-menu-alt-right', 'bx-menu');
                }
            };

            if (activeSection) activeSection.classList.toggle('hide');
            if (sidebar) sidebar.classList.toggle('open');
            menuBtnChange();
        },
        handlerActivePageName() {
            if (this.$route.meta.title) {
                if (this.$route.meta.title === 'Заказы') return 'Лиды';
                return this.$route.meta.title;
            }
            return 'Лиды';
        },
    },
};
</script>
